var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-table", {
    ref: "table",
    attrs: {
      data: _vm.list,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "miniDevNum",
      label: "最小开发数",
      width: "90"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "maxDevNum",
      label: "最大开发数",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "miniRetention",
      label: "最低留存率",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "maxRetention",
      label: "最高留存率",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "settlementRatio",
      label: "结算比例",
      width: "100"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };